module.exports = __webpack_public_path__ + "static/bottom-left-86d6bd1a8a99e203efcf4b9429692d0c.png";